import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges,
   ViewChild
} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import moment from "moment/moment";

@Component({
   selector: 'app-convalida-ricezione',
   templateUrl: './convalida-ricezione.component.html',
   styleUrls: ['./convalida-ricezione.component.scss']
})

export class ConvalidaRicezioneComponent implements OnInit, AfterViewInit, OnChanges {
   @ViewChild("fileInput") fileInput;
   @Output() clickConfirm = new EventEmitter<any>()
   @Output() clickCancel = new EventEmitter<any>()

   @Input() data;
   @Input() popupVisible: boolean = false;

   convalidaFrm = new UntypedFormGroup({})

   constructor() {
      this.initFrm()
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (this.data){
         this.convalidaFrm.patchValue(this.data)
      }
   }

   ngOnInit(): void {
   }

   ngAfterViewInit(): void {
      if (this.fileInput.value?.files?.length > 0) this.fileInput.clear();
   }

   initFrm(){
      this.convalidaFrm = new UntypedFormGroup({
         n_ddt: new UntypedFormControl(null),
      // {value:moment().format('YYYY-MM-DD HH:mm:ss')
         data_ricezione: new UntypedFormControl(moment().format("YYYY-MM-DD"), Validators.required),
         note: new UntypedFormControl('')
      })
   }

   convalidaClick() {
      if (this.convalidaFrm.valid){
         if (this.convalidaFrm.value.data_ricezione != null)
            this.convalidaFrm.value.data_ricezione = moment(this.convalidaFrm.value.data_ricezione).format("YYYY-MM-DD")

         let data = {
            form:this.convalidaFrm.value,
            file: this.fileInput
         }
         this.popupVisible = false
         this.clickConfirm.emit(data)
      }
   }

   chiudiModal(){
      this.popupVisible = false
      this.clickCancel.emit()
   }

}
